var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.22183 18.7781C7.51759 23.0739 14.4824 23.0739 18.7782 18.7781C23.0739 14.4823 23.0739 7.51753 18.7782 3.22176C14.4824 -1.074 7.51759 -1.074 3.22183 3.22176C-1.07394 7.51753 -1.07394 14.4823 3.22183 18.7781Z",
    fill: "#454551"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9801 12.5356L7.86879 15.6469C6.8317 16.684 5.27606 15.1284 6.31315 14.0913L9.42442 10.98L6.37298 7.92856C5.33589 6.89147 6.89153 5.33583 7.92862 6.37292L10.9801 9.42436L14.0913 6.31309C15.1284 5.276 16.684 6.83163 15.647 7.86872L12.5357 10.98L15.5871 14.0314C16.6242 15.0685 15.0686 16.6242 14.0315 15.5871L10.9801 12.5356Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.287049948ed0f4aec136f712c14588da.svg";
export { ForwardRef as ReactComponent };